import { render, staticRenderFns } from "./EditorHeaderGoogleSlideEdit.vue?vue&type=template&id=1d9830d4&scoped=true"
import script from "./EditorHeaderGoogleSlideEdit.vue?vue&type=script&lang=js"
export * from "./EditorHeaderGoogleSlideEdit.vue?vue&type=script&lang=js"
import style0 from "./EditorHeaderGoogleSlideEdit.vue?vue&type=style&index=0&id=1d9830d4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9830d4",
  null
  
)

export default component.exports